export default __webpack_public_path__ + "fonts/eot/iranyekanwebmedium.eot";